import axios from 'axios'

// config
import baseUrl from '../config'

export const createPurchaseRequestBatch = async data => {
  return await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/purchase-request-batches`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })
}

export const deletePurchaseRequestBatch = async ({ batchId }) => {
  return await axios.delete(`${baseUrl}/sef/purchase-request-batches/${batchId}`, {
    withCredentials: true
  })
}

export const fetchPurchaseRequestBatch = async id => {
  const response = await axios.get(`${baseUrl}/sef/purchase-request-batches/${id}`, {
    withCredentials: true
  })
  return response.data
}

export const fetchPurchaseRequestBatches = async params => {
  const response = await axios.get(`${baseUrl}/sef/purchase-request-batches`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const initiatePurchaseRequestPayment = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/purchase-request-batch-payments`,
    data
  })

  return response.data
}

export const updatePurchaseRequestBatch = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'put',
    url: `${baseUrl}/sef/purchase-request-batches/${data.get('id')}`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })

  return response.data
}
